import React from 'react';
import useLocalStorage from 'use-local-storage';
import useTheme from '@hooks/useTheme';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import useIsClinicianSubdomain from '@hooks/useIsClinicianSubdomain';

const BannerContainer = styled.div`
  background-color: var(--productPrimary);
  color: var(--productPrimaryDark);
  padding: 10px 40px;
  font-size: 14px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  width: 100%;
  z-index: 100;
`;

const CloseButton = styled.button`
  position: absolute;
  right: 16px;
  background: transparent;
  border: none;
  font-size: 16px;
  cursor: pointer;
  color: inherit;
  padding: 4px;
  line-height: 1;
  display: flex;
  align-items: center;

  &:hover {
    opacity: 0.7;
  }
`;

export const HAS_SEEN_REBRAND_BANNER_LOCAL_KEY = 'hasSeenRebrandBanner';
const X_ICON_UNICODE = '\u2715';

const RebrandBanner = () => {
  const { isThemeResolved, isHBSTheme } = useTheme();
  const isClinicianSubdomain = useIsClinicianSubdomain();
  const { t } = useTranslation('common');
  const [hasSeenRebrandBanner, setHasSeenRebrandBanner] = useLocalStorage(HAS_SEEN_REBRAND_BANNER_LOCAL_KEY, false);

  if (!isThemeResolved || !isHBSTheme || (isHBSTheme && isClinicianSubdomain) || hasSeenRebrandBanner) return null;

  const handleDismissBanner = () => setHasSeenRebrandBanner(true);

  return (
    <BannerContainer>
      <span>
        <strong>{t('Welcome to HBSUK -')}</strong>{' '}
        {t('A new look, with the same trusted service for AXA Health members.')}
      </span>
      <CloseButton
        data-testid="close-rebrand-banner-button"
        onClick={handleDismissBanner}
        aria-label={t('Close banner')}
      >
        {X_ICON_UNICODE}
      </CloseButton>
    </BannerContainer>
  );
};

export default RebrandBanner;
